import { combineReducers } from "@reduxjs/toolkit";
import misc from "./misc";
import vino from "./vino";
import auth from "./auth";
import settings from "./settings";
import admin from "admin/store";

const createReducer = () => (state, action) => {
	const combinedReducer = combineReducers({
		misc,
		vino,
		auth,
		admin,
		settings,
	});

	/*
	Reset the redux store when user logged out
	 */
	if (action.type === "auth/user/userLoggedOut") {
		state = undefined;
	}

	return combinedReducer(state, action);
};

export default createReducer;
